import { render, staticRenderFns } from "./package.vue?vue&type=template&id=3c134877"
import script from "./package.vue?vue&type=script&lang=ts"
export * from "./package.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports